"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMultipartClient;

var _apolloClient = require("apollo-client");

var _apolloLink = require("apollo-link");

var _apolloUtilities = require("apollo-utilities");

var _apolloLinkError = require("apollo-link-error");

var _apolloCacheInmemory = require("apollo-cache-inmemory");

var _uploadLink = require("./upload-link");

var _authLink = require("./auth-link");

var _retryLink = require("./retry-link");

var _wsLink = require("./ws-link");

function createMultipartClient({
  uri,
  getToken,
  getLanguageCode,
  errorHandler,
  introspectionQueryResultData,
  clientName = process.env.DOOER_SERVICE_NAME,
  dataIdFromObject,
  subscriptionClient
}) {
  const httpLink = (0, _uploadLink.createUploadLink)({
    uri
  });
  const wsLink = (0, _wsLink.createWsLink)({
    getToken,
    getLanguageCode,
    uri,
    subscriptionClient
  });

  const mainLink = _apolloLink.ApolloLink.split(({
    query
  }) => {
    const {
      kind,
      operation
    } = (0, _apolloUtilities.getMainDefinition)(query);
    return !(kind === 'OperationDefinition' && operation === 'subscription');
  }, httpLink, wsLink);

  const link = _apolloLink.ApolloLink.from([(0, _authLink.createAuthLink)({
    getToken,
    getLanguageCode,
    clientName
  }), (0, _retryLink.createRetryLink)(), (0, _apolloLinkError.onError)(errorHandler), mainLink]);

  const fragmentMatcher = new _apolloCacheInmemory.IntrospectionFragmentMatcher({
    introspectionQueryResultData
  });
  const clientOpts = {
    link,
    addTypename: true,
    connectToDevTools: process.env.NODE_ENV === 'development',
    cache: new _apolloCacheInmemory.InMemoryCache({
      fragmentMatcher
    }),
    dataIdFromObject
  };
  return new _apolloClient.ApolloClient(clientOpts);
}